import React, { Component } from 'react'

import logo from "../../assets/images/footerLogo.svg"
import fbIcon from "../../assets/images/fb-icon.svg"
import insIcon from "../../assets/images/ins-icon.svg"
import tIcon from "../../assets/images/t-icon.svg"
import twIcon from "../../assets/images/tw-icon.svg"

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <div className="footer-width">
                    <div className="footer-info">
                        <div className="column-direction">
                            <img src={logo} className="footer-logo" alt="HendrayFinvest logo" />
                            <h6 className="mt-10 light-gt">+2348107196205</h6>
                            <div className="mt-8 footer-icon">
                                <img src={insIcon} alt="Instagram-icon" />
                                <img src={fbIcon} alt="Facebook-icon" />
                                <img src={tIcon} alt="Telegram-icon" />
                                <img src={twIcon} alt="Twitter-icon" />
                            </div>
                            <p className="light-gt light mt-8">getinfo@hendrayfinvest.com</p>
                        </div>
                        <div className="footer-title">
                            <h5 className="mb-15">Legal</h5>
                            <h6>Terms</h6>
                            <h6 className="mt-11">Privacy</h6>
                        </div>
                        <div className="footer-title">
                            <h5 className="mb-15">Company</h5>
                            <h6>About us</h6>
                            <h6 className="mt-11">Subcriptions</h6>
                            <h6 className="mt-11">Risk disclosure</h6>
                        </div>
                        <div className="footer-title">
                            <h5 className="mb-15">Services</h5>
                            <h6>Academy</h6>
                            <h6 className="mt-11">Account management</h6>
                            <h6 className="mt-11">Forex signals</h6>
                            <h6 className="mt-11">Consultancy</h6>
                        </div>
                    </div>
                    <div className="risk-info">
                        FULL RISK DISCLOSURE: Trading contains substantial risk and is not for every investor. An investor could potentially lose all or more than the initial investment. Risk capital is money that can be lost without jeopardizing financial security or life style. Only risk capital should be used for trading and only those with sufficient risk capital should consider trading. Past performance is no guarantee of future results.
                </div>
                </div>
            </footer>
        )
    }
}

export default Footer;